export const SCHEMA = {
  industryTotalAssets: {
    key: 'industryTotalAssets',
    growthKey: 'industryGrowthAssets',
    title: 'industryOverview.industryScale.INDUSTRY_TOTAL_ASSETS',
  },
  industryNetRevenue: {
    key: 'industryNetRevenue',
    growthKey: 'industryGrowthNetRevenue',
    title: 'industryOverview.industryScale.INDUSTRY_NET_REVENUE',
    corpTitle: 'industryOverview.industryScale.CORP_INDUSTRY_NET_REVENUE',
    insTitle: 'industryOverview.industryScale.INS_INDUSTRY_NET_REVENUE',
  },
  industryNumActive: {
    key: 'industryNumActive',
    growthKey: 'industryGrowthActive',
    title: 'industryOverview.industryScale.NUMBER_OF_ACTIVE_BUSINESS',
    bankTitle: 'industryOverview.industryScale.BANKS_NUMBER_OF_ACTIVE_BUSINESS',
    nonBankTitle: 'industryOverview.industryScale.NUMBER_OF_OPERATING_INCOME',
    insTitle: 'industryOverview.industryScale.INS_NUMBER_OF_ACTIVE_BUSINESS',
  },
}
